export const normalizePath = (path: string): string => {
  if (!path) return '/';
  const trimmed = path.trim() || '/';
  const withLeading = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  if (withLeading === '/') return '/';
  return withLeading.replace(/\/+$/, '');
};

export const routeBuilders = {
  home: () => '/',
  explore: () => '/explore',
  login: () => '/login',
  profile: (profileSlug: string) => `/profile/${profileSlug}`,
  library: (profileSlug: string) => `/profile/${profileSlug}/library`,
  mySeries: (profileSlug: string) => `/profile/${profileSlug}/series`,
  seriesEdit: (profileSlug: string, seriesSlug: string) => `/profile/${profileSlug}/series/${seriesSlug}`,
  seriesPublic: (seriesSlug: string) => `/series/${seriesSlug}`,
  episodePublic: (seriesSlug: string, episodeSlug: string) => `/series/${seriesSlug}/${episodeSlug}`,
  creatorPublic: (creatorSlug: string) => `/creator/${creatorSlug}`,
};
